import React, { useEffect } from "react";
import M from "materialize-css";
import "./face.css";

function PageFace() {
  useEffect(() => {
    M.Modal.init(document.querySelectorAll(".modal"), {});
    M.Collapsible.init(
      document.querySelectorAll(".collapsible.procedimentos"),
      {}
    );
  }, []);

  const procedimentos = [
    {
      id: "modal-blefaroplastia",
      titulo: "Blefaroplastia",
      descricao: "Rejuvenescendo o olhar com naturalidade",
      imagem: "/images/procedimentos/blefarosplastia.png",
      modalContent: {
        titulo: "Blefaroplastia",
        descricao:
          "A blefaroplastia é uma cirurgia plástica destinada a corrigir excesso de pele, bolsas de gordura ou flacidez nas pálpebras. Realizada tanto na pálpebra superior quanto inferior, a técnica promove um olhar mais jovem e descansado, mantendo a naturalidade. Na blefaroplastia inferior, uma opção é a técnica transconjuntival, que evita cortes externos e garante cicatrizes invisíveis, sendo bem indicada quando ainda não há flacidez de pele, somente as bolsas palpebrais. Para pacientes com depressão acentuada na área das olheiras, é possível ainda realizar a transposição de gordura, redistribuindo os tecidos para suavizar a região e oferecer resultados harmônicos. A blefaroplastia é conhecida pela recuperação rápida e resultados duradouros.",
        perguntas: [
          {
            pergunta: "Quem pode fazer blefaroplastia?",
            resposta:
              "Pessoas com flacidez ou bolsas de gordura nas pálpebras, geralmente a partir dos 35 anos, são candidatas ideais.",
          },
          {
            pergunta: "A cicatriz fica visível?",
            resposta:
              "Na pálpebra superior, a cicatriz é discreta e fica escondida na dobra natural. Na inferior, ela também é discreta, misturando-se com as rugas naturais.",
          },
          {
            pergunta: "A cirurgia ajuda nas olheiras?",
            resposta:
              "Sim! A transposição de gordura pode suavizar a depressão presente nas olheiras, melhorando o aspecto geral da região.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial dura cerca de 7 a 10 dias, com retorno às atividades em até 2 semanas.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "Embora duradouros, os resultados podem ser impactados pelo envelhecimento natural e pelo estilo de vida.",
          },
        ],
      },
    },
    {
      id: "modal-liftingFacial",
      titulo: "Lifting Facial",
      descricao: "Rejuvenescimento com naturalidade",
      imagem: "/images/procedimentos/lifting.png",
      modalContent: {
        titulo: "Lifting Facial",
        descricao:
          "O lifting facial é uma cirurgia plástica que visa reposicionar tecidos faciais, corrigindo flacidez e redefinindo os contornos do rosto e pescoço. Disponível em versão completa ou mini-lifting, é indicado para pacientes que buscam um rejuvenescimento facial sem perder a naturalidade. A técnica promove resultados harmônicos, com foco em suavizar os sinais do envelhecimento e preservar as características individuais do paciente. A recuperação é gradual, com retorno às atividades em algumas semanas, e os resultados duradouros podem ser potencializados por cuidados com a pele e um estilo de vida saudável.",
        perguntas: [
          {
            pergunta: "Quem pode fazer lifting facial?",
            resposta:
              "É indicado para pessoas com flacidez facial moderada a severa que desejam melhorar os contornos do rosto e do pescoço.",
          },
          {
            pergunta: "O resultado parece natural?",
            resposta:
              "Sim! O objetivo é suavizar os sinais do envelhecimento sem alterar as feições do paciente.",
          },
          {
            pergunta: "Quais áreas o lifting trata?",
            resposta:
              "Ele aborda flacidez no rosto, pescoço e área da linha da mandíbula.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial leva cerca de 2 a 3 semanas, com melhora progressiva.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "Os resultados são duradouros, mas o envelhecimento natural pode impactá-los ao longo dos anos.",
          },
        ],
      },
    },
    {
      id: "modal-otoplastia",
      titulo: "Otoplastia",
      descricao: "Correção das orelhas com harmonia",
      imagem: "/images/procedimentos/otoplastia.png",
      modalContent: {
        titulo: "Otoplastia",
        descricao:
          "A otoplastia é uma cirurgia plástica que corrige a projeção das orelhas em abano, melhorando a harmonia facial. Pode ser realizada a partir dos 8 anos de idade, quando as orelhas já estão desenvolvidas o suficiente, proporcionando conforto emocional principalmente para crianças em idade escolar. É essencial que, principalmente após a adolescência, a decisão pela cirurgia seja um desejo do próprio indivíduo, e não dos pais. O procedimento é seguro e resulta em cicatrizes discretas, localizadas atrás das orelhas, ficando praticamente invisíveis após a recuperação.",
        perguntas: [
          {
            pergunta: "Quem pode fazer otoplastia?",
            resposta:
              "A cirurgia é indicada para pessoas com orelhas em abano, a partir dos 8 anos de idade.",
          },
          {
            pergunta: "As cicatrizes são visíveis?",
            resposta:
              "Não. Elas são discretas e ficam escondidas atrás das orelhas.",
          },
          {
            pergunta: "O procedimento é doloroso?",
            resposta:
              "O desconforto é leve e controlado com medicamentos. A dor é mínima.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial leva cerca de 7 a 10 dias, e o paciente segue usando faixa de proteção por cerca de 30 dias.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "Sim, os resultados da otoplastia são definitivos e duradouros.",
          },
        ],
      },
    },
    {
      id: "modal-mentoplastia",
      titulo: "Mentoplastia",
      descricao: "Redefinindo os contornos faciais",
      imagem: "/images/procedimentos/mentoplastia.png",
      modalContent: {
        titulo: "Mentoplastia",
        descricao:
          "A mentoplastia é uma cirurgia plástica que corrige o formato e o tamanho do queixo, promovendo maior harmonia facial. Indicada para pacientes com queixo retraído ou desproporcional em relação ao restante do rosto, a técnica utiliza próteses de silicone para aumentar e definir o contorno facial. Com foco na naturalidade, a mentoplastia é planejada individualmente, levando em consideração as características únicas do paciente. O procedimento resulta em uma aparência equilibrada e esteticamente agradável, com cicatrizes discretas localizadas em regiões pouco visíveis.",
        perguntas: [
          {
            pergunta: "Quem pode fazer mentoplastia?",
            resposta:
              "Pacientes com queixo retraído ou que desejam melhorar o contorno facial.",
          },
          {
            pergunta: "As cicatrizes são visíveis?",
            resposta:
              "Não. As cicatrizes são discretas e podem ficar localizadas dentro da boca ou em áreas pouco aparentes, sob o queixo.",
          },
          {
            pergunta: "O procedimento altera a mordida?",
            resposta:
              "Não. A mentoplastia não interfere no alinhamento dentário ou na mordida.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial leva cerca de 7 a 10 dias, com retorno gradual às atividades.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "Sim, os resultados são duradouros, embora possam ser influenciados pelo processo de envelhecimento.",
          },
        ],
      },
    },
    {
      id: "modal-liftingSobrancelha",
      titulo: "Lifting de Sobrancelhas",
      descricao: "Rejuvenescimento do olhar",
      imagem: "/images/procedimentos/lifting_sobrancelhas.png",
      modalContent: {
        titulo: "Lifting de Sobrancelhas",
        descricao:
          "O lifting de sobrancelhas é uma cirurgia plástica que eleva e reposiciona as sobrancelhas, suavizando linhas de expressão e conferindo um olhar mais jovem e descansado. Indicada para pacientes com sobrancelhas caídas ou com excesso de pele na região frontal, a técnica promove resultados naturais e harmônicos. O procedimento é planejado de forma personalizada, considerando as características individuais do rosto. As cicatrizes são discretas e geralmente ficam escondidas no couro cabeludo, em linhas naturais da pele ou, em pacientes com testa alta, nas linhas do cabelo, proporcionando maior confiança ao paciente.",
        perguntas: [
          {
            pergunta: "Quem pode fazer lifting de sobrancelha?",
            resposta:
              "Pessoas com sobrancelhas caídas ou que desejam um olhar mais rejuvenescido.",
          },
          {
            pergunta: "Onde ficam as cicatrizes?",
            resposta:
              "O local das cicatrizes varia conforme o caso, podendo estar no couro cabeludo, em linhas naturais da pele ou nas linhas do cabelo, ou das sobrancelhas.",
          },
          {
            pergunta: "O procedimento causa dor?",
            resposta:
              "A percepção de dor é subjetiva, variando entre os pacientes. Geralmente, o desconforto é bem tolerado e aliviado com analgésicos prescritos pelo médico.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial leva de 7 a 10 dias, com melhora progressiva.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "Sim, mas os efeitos do envelhecimento natural podem influenciar ao longo dos anos.",
          },
        ],
      },
    },
    {
      id: "modal-lipofillingFacial",
      titulo: "Lipofilling Facial",
      descricao: "Rejuvenescimento com volume natural",
      imagem: "/images/procedimentos/lipolifting.png",
      modalContent: {
        titulo: "Lipofilling Facial",
        descricao:
          "O lipofilling facial é um procedimento que utiliza a própria gordura do paciente para preencher áreas do rosto que perderam volume com o tempo. Ideal para quem deseja suavizar sulcos, rugas ou restaurar a firmeza da pele de forma natural, o procedimento alia segurança e resultados harmônicos. A gordura é retirada de regiões do corpo com excesso, como abdômen ou coxas, e, após ser processada, é enxertada nas áreas desejadas do rosto. O lipofilling também pode ser combinado a outras cirurgias para potencializar os resultados, oferecendo um rejuvenescimento completo.",
        perguntas: [
          {
            pergunta: "Quem pode fazer lipofilling facial?",
            resposta:
              "Pessoas com perda de volume facial ou que desejam suavizar rugas e sulcos de forma natural.",
          },
          {
            pergunta: "O resultado parece natural?",
            resposta:
              "Sim! Por utilizar gordura própria, os resultados são extremamente naturais e duradouros.",
          },
          {
            pergunta: "O procedimento é seguro?",
            resposta:
              "Sim, por usar gordura do próprio paciente, o risco de rejeição é muito baixo.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial leva cerca de 7 a 10 dias, com retorno gradual às atividades.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "Em parte. Uma porção da gordura enxertada é reabsorvida pelo corpo, mas o volume restante é duradouro.",
          },
        ],
      },
    },
    {
      id: "modal-liftingCervical",
      titulo: "Lifting Cervical",
      descricao: "Redefinindo os contornos do pescoço",
      imagem: "/images/procedimentos/lifting cervical.png",
      modalContent: {
        titulo: "Lifting Cervical",
        descricao:
          "O lifting cervical é uma cirurgia plástica que melhora o contorno do pescoço, eliminando flacidez e excesso de pele. Indicada para pacientes com sinais de envelhecimento na região cervical, a técnica promove um rejuvenescimento significativo e natural. O procedimento é realizado de forma personalizada, considerando as necessidades e características de cada paciente. As cicatrizes são discretas, posicionadas estrategicamente para ficarem pouco visíveis, geralmente atrás das orelhas, na linha natural do cabelo e, em alguns casos, abaixo do queixo.",
        perguntas: [
          {
            pergunta: "Quem pode fazer lifting cervical?",
            resposta:
              "Pacientes com flacidez ou excesso de pele na região do pescoço que desejam melhorar o contorno cervical.",
          },
          {
            pergunta: "As cicatrizes são visíveis?",
            resposta:
              "Não. Elas são discretas e ficam posicionadas atrás das orelhas e na linha natural do cabelo.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial dura cerca de 10 a 14 dias, com retorno gradual às atividades.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "Sim, mas o processo de envelhecimento natural pode impactar os resultados ao longo dos anos.",
          },
          {
            pergunta: "O procedimento pode ser combinado com outras cirurgias?",
            resposta:
              "Sim, mas os efeitos do envelhecimento natural podem influenciar ao longo dos anos.",
          },
        ],
      },
    },
  ];

  return (
    <div>
      <div>
        <h3 className="titulo-cirurgias-page-face">Face</h3>
      </div>

      {procedimentos.map((procedimento, index) => (
        <div
          key={index}
          className="row-page-face"
          id={`containerProcedimentosText${index % 2 === 0 ? "Right" : "Left"}`}
        >
          <div className="col-page-face s12">
            <div
              className={`hoverable container-page-face ${index % 2 === 0 ? "even" : "odd"}`}
            >
              <div className="image-container-page-face">
                <img src={procedimento.imagem} alt={procedimento.titulo} />
              </div>
              <div
                className={`text-container-page-face ${index % 2 === 0 ? "right" : "left"}`}
              >
                <h5 className="card-title-page-face">{procedimento.titulo}</h5>
                <p className="card-description-page-face">
                  {procedimento.descricao}
                </p>
                <a
                  className="modal-trigger custom-btn"
                  href={`#${procedimento.id}`}
                >
                  Saiba mais
                </a>
              </div>
            </div>
          </div>

          <div id={procedimento.id} className="modal">
            <a href="#!" className="modal-close btn-close-icon">
              <i className="material-icons">close</i>
            </a>
            <div className="modal-content-page-face">
              <h4 className="modal-title-page-face">
                {procedimento.modalContent.titulo}
              </h4>
              <p className="modal-description-page-face">
                {procedimento.modalContent.descricao}
              </p>
              <h5 className="questions-title-page-face">
                Perguntas Frequentes
              </h5>
              <ul className="collapsible procedimentos">
                {procedimento.modalContent.perguntas.map((pergunta, idx) => (
                  <li key={idx}>
                    <div className="collapsible-header procedimentos-header-page-face">
                      {pergunta.pergunta}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M6 9l6 6 6-6" />
                      </svg>
                    </div>
                    <div className="collapsible-body procedimentos-body-page-face">
                      <p className="question-page-face">{pergunta.resposta}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default PageFace;
